/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Label,
  Modal,
  Table,
  TextInput,
  Badge,
  Avatar,
} from "flowbite-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import type { FC } from "react";
import * as XLSX from "xlsx";
import { useEffect, useState } from "react";
import {
  HiBell,
  HiCheckCircle,
  HiChevronLeft,
  HiChevronRight,
  HiCog,
  HiDocumentDownload,
  HiDotsVertical,
  HiExclamationCircle,
  HiHome,
  HiOutlineExclamationCircle,
  HiOutlinePencilAlt,
  HiPlus,
  HiSave,
  HiTrash,
  HiUpload,
  HiUserAdd,
  HiUsers,
  HiXCircle,
  HiMail,
  HiPhone,
  HiLink,
  HiOfficeBuilding,
  HiClock,
} from "react-icons/hi";
import NavbarSidebarLayout from "../layouts/navbar-sidebar";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { format, parse } from "date-fns";
import { FadeLoader } from "react-spinners";

import { NotificationBellDropdown } from "./navbar";
import { useAppContext } from "../context/AppContext";
import { companyService, contactService } from "../services/main";
const UserListPage: FC = function () {
  return (
    <NavbarSidebarLayout isFooter={false}>
      <div className="block items-center justify-between border-b border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex">
        <div className="mb-1 w-full">
          <div className="mb-4">
            <Breadcrumb className="mb-4">
              <Breadcrumb.Item>
                <div className="flex items-center gap-x-3">
                  <HiHome className="text-xl" />
                  <span className="dark:text-white">Home</span>
                </div>
              </Breadcrumb.Item>
              <Breadcrumb.Item href="/users/list">Users</Breadcrumb.Item>
              <Breadcrumb.Item>List</Breadcrumb.Item>
            </Breadcrumb>
            <h1 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">
              All users
            </h1>
          </div>
          <div className="sm:flex">
            <div className="mb-3 hidden items-center dark:divide-gray-700 sm:mb-0 sm:flex sm:divide-x sm:divide-gray-100">
              <form className="lg:pr-3">
                <Label htmlFor="users-search" className="sr-only">
                  Search
                </Label>
                <div className="relative mt-1 lg:w-64 xl:w-96">
                  <TextInput
                    id="users-search"
                    name="users-search"
                    placeholder="Search for users"
                  />
                </div>
              </form>
              <div className="mt-3 flex space-x-1 pl-0 sm:mt-0 sm:pl-2">
                <a className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                  <span className="sr-only">Configure</span>
                  <HiCog className="text-2xl" />
                </a>
                <a className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                  <span className="sr-only">Delete</span>
                  <HiTrash className="text-2xl" />
                </a>
                <a className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                  <span className="sr-only">Purge</span>
                  <HiExclamationCircle className="text-2xl" />
                </a>
                <a className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                  <span className="sr-only">Settings</span>
                  <HiDotsVertical className="text-2xl" />
                </a>
              </div>
            </div>
            <div className="ml-auto flex items-center space-x-2 sm:space-x-3">
              <AddContactModal />
              <Button color="gray">
                <div className="flex items-center gap-x-3">
                  <HiDocumentDownload className="text-xl" />
                  <span>Export</span>
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="inline-block min-w-full align-middle">
            <div className="overflow-hidden shadow">
              {/* <AllContactsTable /> */}
            </div>
          </div>
        </div>
      </div>
    </NavbarSidebarLayout>
  );
};



const initialFormData = {
  firstName: "",
  lastName: "",
  pronoun: "",
  companyId: "",
  title: "",
  email: "",
  phoneNumbers: [{ number: "", type: "Work" }], // at least one number
  linkedinUrl: "",
  backgroundInfo: "",
  hasNewsletter: false,
};

// Dropdown options
const PRONOUN_OPTIONS = [
  { value: "", label: "Select Pronoun" },
  { value: "Mr", label: "Mr" },
  { value: "Mrs", label: "Mrs" },
  { value: "Ms", label: "Ms" },
  { value: "Dr", label: "Dr" },
  { value: "Prof", label: "Prof" },
  { value: "Sir", label: "Sir" },
  { value: "Madam", label: "Madam" },
];

const TITLE_OPTIONS = [
  { value: "", label: "Select Title" },
  { value: "CEO", label: "CEO" },
  { value: "CTO", label: "CTO" },
  { value: "CFO", label: "CFO" },
  { value: "COO", label: "COO" },
  { value: "President", label: "President" },
  { value: "Vice President", label: "Vice President" },
  { value: "Director", label: "Director" },
  { value: "Manager", label: "Manager" },
  { value: "Senior Manager", label: "Senior Manager" },
  { value: "Assistant Manager", label: "Assistant Manager" },
  { value: "Executive", label: "Executive" },
  { value: "Senior Executive", label: "Senior Executive" },
  { value: "Analyst", label: "Analyst" },
  { value: "Senior Analyst", label: "Senior Analyst" },
  { value: "Consultant", label: "Consultant" },
  { value: "Senior Consultant", label: "Senior Consultant" },
  { value: "Engineer", label: "Engineer" },
  { value: "Senior Engineer", label: "Senior Engineer" },
  { value: "Developer", label: "Developer" },
  { value: "Designer", label: "Designer" },
  { value: "Sales Representative", label: "Sales Representative" },
  { value: "Account Manager", label: "Account Manager" },
  { value: "Project Manager", label: "Project Manager" },
  { value: "Product Manager", label: "Product Manager" },
  { value: "Marketing Manager", label: "Marketing Manager" },
  { value: "HR Manager", label: "HR Manager" },
  { value: "Operations Manager", label: "Operations Manager" },
  { value: "Other", label: "Other" },
];

const PHONE_TYPE_OPTIONS = [
  { value: "Work", label: "Work" },
  { value: "Mobile", label: "Mobile" },
  { value: "Home", label: "Home" },
  { value: "Fax", label: "Fax" },
  { value: "Other", label: "Other" },
];


export const AddContactModal: FC = () => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false)
  const { contacts, setContacts, companies, setCompanies } = useAppContext();
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [formData, setFormData] = useState(initialFormData) as any;
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await companyService.listCompanies();
        setCompanies(response.data.companies);
      } catch (err) {
        console.error("Failed to fetch companies", err);
      }
    };
    fetchCompanies();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;

    // contextLinks handled as comma-separated
    if (name === "contextLinks") {
      setFormData((prev: any) => ({
        ...prev,
        contextLinks: value.split(",").map(link => link.trim()),
      }));
    }
    else {
      setFormData((prev: any) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handlePhoneNumberChange = (index: number, field: string, value: string) => {
    const updated = [...formData.phoneNumbers];
    updated[index][field] = value;
    setFormData((prev: any) => ({
      ...prev,
      phoneNumbers: updated,
    }));
  };

  const addPhoneNumberField = () => {
    setFormData((prev: any) => ({
      ...prev,
      phoneNumbers: [...prev.phoneNumbers, { number: "", type: "Work" }],
    }));
  };

  const handleAddContact = async () => {
    // Validation
    if (!formData.pronoun) {
      alert("Please select a pronoun");
      return;
    }
    if (!formData.firstName || !formData.lastName) {
      alert("First name and last name are required");
      return;
    }
    if (!formData.phoneNumbers[0]?.number) {
      alert("At least one phone number is required");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        ...formData,
        accountManagerId: user.id,
        // Clean up empty phone numbers
        phoneNumbers: formData.phoneNumbers.filter((phone: any) => phone.number.trim() !== ""),
      };
      const response = await contactService.createContact(payload);
      onUpdate();
      setFormData(initialFormData);
      setOpen(false);
      // Show success message (you can use toast notification here)
      alert("Contact added successfully!");
    } catch (error: any) {
      console.error("Failed to add contact", error);
      alert(error?.response?.data?.message || "Failed to add contact. Please try again.");
    } finally {
      setLoading(false);
    }
  };


const handleContactDataExport = () => {
  const excludeFields = ["id", "accountManagerId", "createdAt", "updatedAt", "hasNewsletter"];

  const transformed = contacts.map((item: any) => {
    const result: any = {};

    Object.entries(item).forEach(([key, value]:any) => {
      if (excludeFields.includes(key)) return;

      // Flatten phoneNumbers array
      if (key === "phoneNumbers" && Array.isArray(value)) {
        result["phoneNumbers"] = value.map((v) => `${v.type}: ${v.number}`).join(", ");
        return;
      }

      // Flatten company object
      if (key === "company" && typeof value === "object" && value !== null) {
        result["company"] = value.name || "";
        result["companyWebsite"] = value.website || "";
        result["companyLinkedIn"] = value.linkedinUrl || "";
        return;
      }

      result[key] = Array.isArray(value) ? value.join(", ") : value;
    });

    return result;
  });

  const worksheet = XLSX.utils.json_to_sheet(transformed);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Contacts");

  XLSX.writeFile(workbook, "contacts_export.xlsx");
};


  const onUpdate = async () => {
    try {
      setLoading(true);
      const response = await contactService.listContacts();
      const sorted = response.data.contacts.sort((a: any, b: any) => a.id - b.id);
      setContacts(sorted);
    } catch (error) {
      console.error("Failed to refresh contacts", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>

      <Button color="primary" onClick={() => {
        setOpen(true)
      }}>
        <div className="flex items-center gap-x-3">
          <HiPlus className="text-xl" />
          New Contact
        </div>
      </Button>
      <Button color="gray" onClick={handleContactDataExport}>
        <div className="flex items-center gap-x-3">
          <HiDocumentDownload className="text-xl" />
          <span>Export</span>
        </div>
      </Button>
      {/* <Button color="gray" onClick={()=>{

      }}>
        <div className="flex items-center gap-x-3">
          <HiUpload className="text-xl" />
          <span>Import</span>
        </div>
      </Button> */}
      <ImportContactsModal contact={contacts} onUpdate={onUpdate} />
      <Modal size="xl" onClose={() => setOpen(false)} show={isOpen}>
        <Modal.Header className="border-b border-gray-200 !p-4 dark:border-gray-700">
          <strong>Add New Contact</strong>
        </Modal.Header>
        <Modal.Body className="max-h-[70vh] overflow-y-auto">
          <div className="space-y-4">
            {/* Basic Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Basic Information</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {/* Pronoun Dropdown */}
                <div className="flex flex-col">
                  <Label htmlFor="pronoun" className="mb-2">
                    Pronoun <span className="text-red-500">*</span>
                  </Label>
                  <select
                    id="pronoun"
                    name="pronoun"
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    value={formData.pronoun}
                    onChange={handleChange}
                    required
                  >
                    {PRONOUN_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* First Name */}
                <div className="flex flex-col">
                  <Label htmlFor="firstName" className="mb-2">
                    First Name <span className="text-red-500">*</span>
                  </Label>
                  <TextInput
                    id="firstName"
                    name="firstName"
                    placeholder="Enter first name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Last Name */}
                <div className="flex flex-col">
                  <Label htmlFor="lastName" className="mb-2">
                    Last Name <span className="text-red-500">*</span>
                  </Label>
                  <TextInput
                    id="lastName"
                    name="lastName"
                    placeholder="Enter last name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Title Dropdown */}
                <div className="flex flex-col">
                  <Label htmlFor="title" className="mb-2">Job Title</Label>
                  <select
                    id="title"
                    name="title"
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    value={formData.title}
                    onChange={handleChange}
                  >
                    {TITLE_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Company Dropdown */}
                <div className="flex flex-col">
                  <Label htmlFor="companyId" className="mb-2">Company</Label>
                  <select
                    id="companyId"
                    name="companyId"
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    value={formData.companyId}
                    onChange={handleChange}
                  >
                    <option value="">Select Company</option>
                    {companies.map((company: any) => (
                      <option key={company.id} value={company.id}>
                        {company.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Email */}
                <div className="flex flex-col">
                  <Label htmlFor="email" className="mb-2">Email</Label>
                  <TextInput
                    id="email"
                    name="email"
                    type="email"
                    placeholder="example@email.com"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            {/* Contact Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Contact Information</h3>
              
              {/* Phone Numbers */}
              <div className="mb-4">
                <Label className="mb-2 block">
                  Phone Numbers <span className="text-red-500">*</span>
                </Label>
                {formData.phoneNumbers.map((phone: any, index: number) => (
                  <div key={index} className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-2">
                    <div className="sm:col-span-2">
                      <TextInput
                        placeholder="Phone number (e.g., +1 234 567 8900)"
                        value={phone.number}
                        onChange={(e) => handlePhoneNumberChange(index, "number", e.target.value)}
                        required={index === 0}
                      />
                    </div>
                    <div>
                      <select
                        className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white w-full"
                        value={phone.type}
                        onChange={(e) => handlePhoneNumberChange(index, "type", e.target.value)}
                      >
                        {PHONE_TYPE_OPTIONS.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                ))}
                <Button color="gray" size="xs" className="mt-2" onClick={addPhoneNumberField}>
                  + Add Another Number
                </Button>
              </div>

              {/* LinkedIn URL */}
              <div className="mb-4">
                <Label htmlFor="linkedinUrl" className="mb-2">LinkedIn URL</Label>
                <TextInput
                  id="linkedinUrl"
                  name="linkedinUrl"
                  type="url"
                  placeholder="https://linkedin.com/in/username"
                  value={formData.linkedinUrl}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Additional Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Additional Information</h3>
              
              {/* Background Info */}
              <div className="mb-4">
                <Label htmlFor="backgroundInfo" className="mb-2">Background Information</Label>
                <textarea
                  id="backgroundInfo"
                  name="backgroundInfo"
                  rows={4}
                  className="block w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                  placeholder="Enter any additional background information about this contact..."
                  value={formData.backgroundInfo}
                  onChange={(e) => setFormData((prev: any) => ({ ...prev, backgroundInfo: e.target.value }))}
                />
              </div>

              {/* Newsletter Checkbox */}
              <div className="flex items-center">
                <Checkbox
                  id="hasNewsletter"
                  checked={formData.hasNewsletter}
                  onChange={(e) => setFormData((prev: any) => ({ ...prev, hasNewsletter: e.target.checked }))}
                />
                <Label htmlFor="hasNewsletter" className="ml-2">
                  Subscribe to newsletter
                </Label>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-t border-gray-200 dark:border-gray-700 !p-4">
          <div className="flex justify-end gap-2 w-full">
            <Button color="gray" onClick={() => setOpen(false)} disabled={loading}>
              Cancel
            </Button>
            <Button color="primary" onClick={handleAddContact} disabled={loading}>
              {loading ? "Adding..." : "Add Contact"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>


    </>
  );
};




// { searchTerm, filters } as prop later use
export const AllContactsTable: FC<any> = ({ paginatedContacts, searchTerm }) => {
  // const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { contacts, setContacts } = useAppContext();


  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await contactService.listContacts();
        setContacts(response.data.contacts);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch contacts", error);
      }
    };

    fetchContacts();
  }, []);
  const excludedColumns = ['id', 'accountManagerId', 'companyId', 'createdAt', 'updatedAt', "hasNewsletter"];

  const onUpdate = async () => {
    try {
      setLoading(true);
      const response = await contactService.listContacts();
      const sorted = response.data.contacts.sort((a: any, b: any) => a.id - b.id);
      setContacts(sorted);
    } catch (error) {
      console.error("Failed to refresh contacts", error);
    } finally {
      setLoading(false);
    }
  };

  // Use paginatedContacts directly (already filtered in parent)
  const displayContacts = paginatedContacts || [];

  // Get column headers from first contact if available
  const getTableHeaders = () => {
    if (displayContacts.length === 0 && contacts.length > 0) {
      // Use first contact from all contacts for headers
      const firstContact = contacts[0];
      return Object.keys(firstContact)
        .filter((key) => !excludedColumns.includes(key) && key.toLowerCase() !== 'accountmanager')
        .map((key) => ({
          key,
          label: key.replace(/([A-Z])/g, " $1").trim()
        }));
    }
    if (displayContacts.length > 0) {
      return Object.keys(displayContacts[0])
        .filter((key) => !excludedColumns.includes(key) && key.toLowerCase() !== 'accountmanager')
        .map((key) => ({
          key,
          label: key.replace(/([A-Z])/g, " $1").trim()
        }));
    }
    return [];
  };

  const tableHeaders = getTableHeaders();

  // Inline Editable Status Component
  const InlineStatusEditor: FC<{ status: string; contactId: number; onUpdate: () => void }> = ({ status, contactId, onUpdate }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [currentStatus, setCurrentStatus] = useState(status);

    const statusConfig: Record<string, { color: string; label: string; bgClass: string; textClass: string; borderClass: string }> = {
      NEW: { 
        color: "info", 
        label: "New", 
        bgClass: "bg-blue-100 dark:bg-blue-900/30",
        textClass: "text-blue-800 dark:text-blue-300",
        borderClass: "border-blue-200 dark:border-blue-800"
      },
      CONTACTED: { 
        color: "success", 
        label: "Contacted", 
        bgClass: "bg-green-100 dark:bg-green-900/30",
        textClass: "text-green-800 dark:text-green-300",
        borderClass: "border-green-200 dark:border-green-800"
      },
      INVALID: { 
        color: "failure", 
        label: "Invalid", 
        bgClass: "bg-red-100 dark:bg-red-900/30",
        textClass: "text-red-800 dark:text-red-300",
        borderClass: "border-red-200 dark:border-red-800"
      },
      FOLLOW_UP: { 
        color: "warning", 
        label: "Follow Up", 
        bgClass: "bg-yellow-100 dark:bg-yellow-900/30",
        textClass: "text-yellow-800 dark:text-yellow-300",
        borderClass: "border-yellow-200 dark:border-yellow-800"
      },
    };

    const config = statusConfig[currentStatus] || statusConfig.NEW;

    const handleStatusChange = async (newStatus: string) => {
      if (newStatus === currentStatus) {
        setIsEditing(false);
        return;
      }
      try {
        setUpdating(true);
        await contactService.updateContact(contactId, { status: newStatus });
        setCurrentStatus(newStatus);
        setIsEditing(false);
        onUpdate();
        toast.success("Status updated successfully!");
      } catch (error) {
        console.error("Failed to update status", error);
        toast.error("Failed to update status");
      } finally {
        setUpdating(false);
      }
    };

    useEffect(() => {
      setCurrentStatus(status);
    }, [status]);

    if (isEditing) {
      return (
        <select
          value={currentStatus}
          onChange={(e) => handleStatusChange(e.target.value)}
          onBlur={() => setIsEditing(false)}
          autoFocus
          disabled={updating}
          className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold border cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 ${config.bgClass} ${config.textClass} ${config.borderClass}`}
          onClick={(e) => e.stopPropagation()}
        >
          <option value="NEW">New</option>
          <option value="CONTACTED">Contacted</option>
          <option value="INVALID">Invalid</option>
          <option value="FOLLOW_UP">Follow Up</option>
        </select>
      );
    }

    return (
      <span 
        onClick={(e) => {
          e.stopPropagation();
          setIsEditing(true);
        }}
        className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold border cursor-pointer hover:opacity-80 transition-opacity ${config.bgClass} ${config.textClass} ${config.borderClass}`}
        title="Click to change status"
      >
        <span className={`w-2 h-2 rounded-full ${config.textClass.includes('blue') ? 'bg-blue-600' : config.textClass.includes('green') ? 'bg-green-600' : config.textClass.includes('red') ? 'bg-red-600' : 'bg-yellow-600'}`}></span>
        {config.label}
      </span>
    );
  };

  const getStatusBadge = (status: string) => {
    const statusConfig: Record<string, { color: string; label: string; bgClass: string; textClass: string; borderClass: string }> = {
      NEW: { 
        color: "info", 
        label: "New", 
        bgClass: "bg-blue-100 dark:bg-blue-900/30",
        textClass: "text-blue-800 dark:text-blue-300",
        borderClass: "border-blue-200 dark:border-blue-800"
      },
      CONTACTED: { 
        color: "success", 
        label: "Contacted", 
        bgClass: "bg-green-100 dark:bg-green-900/30",
        textClass: "text-green-800 dark:text-green-300",
        borderClass: "border-green-200 dark:border-green-800"
      },
      INVALID: { 
        color: "failure", 
        label: "Invalid", 
        bgClass: "bg-red-100 dark:bg-red-900/30",
        textClass: "text-red-800 dark:text-red-300",
        borderClass: "border-red-200 dark:border-red-800"
      },
      FOLLOW_UP: { 
        color: "warning", 
        label: "Follow Up", 
        bgClass: "bg-yellow-100 dark:bg-yellow-900/30",
        textClass: "text-yellow-800 dark:text-yellow-300",
        borderClass: "border-yellow-200 dark:border-yellow-800"
      },
    };

    const config = statusConfig[status] || statusConfig.NEW;

    return (
      <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold border ${config.bgClass} ${config.textClass} ${config.borderClass}`}>
        <span className={`w-2 h-2 rounded-full ${config.textClass.includes('blue') ? 'bg-blue-600' : config.textClass.includes('green') ? 'bg-green-600' : config.textClass.includes('red') ? 'bg-red-600' : 'bg-yellow-600'}`}></span>
        {config.label}
      </span>
    );
  };

  return (
    <div className="overflow-x-auto">
      <Table className="min-w-full">
        <Table.Head className="bg-gray-50 dark:bg-gray-800 border-b-2 border-gray-200 dark:border-gray-700">
          <Table.HeadCell className="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Contact
          </Table.HeadCell>
          <Table.HeadCell className="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Company
          </Table.HeadCell>
          <Table.HeadCell className="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Email
          </Table.HeadCell>
          <Table.HeadCell className="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Phone
          </Table.HeadCell>
          <Table.HeadCell className="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Title
          </Table.HeadCell>
          <Table.HeadCell className="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Status
          </Table.HeadCell>
          <Table.HeadCell className="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Account Manager
          </Table.HeadCell>
          <Table.HeadCell className="px-4 py-3 text-center text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Actions
          </Table.HeadCell>
        </Table.Head>
        <Table.Body className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
          {loading ? (
            <Table.Row>
              <Table.Cell colSpan={8} className="text-center py-12">
                <div className="flex flex-col justify-center items-center">
                  <FadeLoader color="#3b82f6" />
                  <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">Loading contacts...</p>
                </div>
              </Table.Cell>
            </Table.Row>
          ) : displayContacts.length === 0 ? (
            <Table.Row>
              <Table.Cell colSpan={8} className="text-center py-12">
                <div className="flex flex-col items-center justify-center">
                  <HiUsers className="w-16 h-16 text-gray-300 dark:text-gray-600 mb-3" />
                  <p className="text-lg font-medium text-gray-900 dark:text-white mb-1">
                    No contacts found
                  </p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {searchTerm ? "Try adjusting your search or filters" : "Create your first contact to get started"}
                  </p>
                </div>
              </Table.Cell>
            </Table.Row>
          ) : (
            displayContacts.map((contact: any, index: number) => {
              const firstName = contact.firstName || "";
              const lastName = contact.lastName || "";
              const fullName = `${firstName} ${lastName}`.trim() || "Unknown";
              const initials = `${firstName[0] || ""}${lastName[0] || ""}`.toUpperCase() || "?";
              const email = contact.email || "";
              const phoneNumbers = contact.phoneNumbers || [];
              const company = contact.company?.name || "No company";
              const title = contact.title || "-";
              const status = contact.status || "NEW";
              const accountManager = contact.accountManager && typeof contact.accountManager === 'object'
                ? `${contact.accountManager.firstName || ''} ${contact.accountManager.lastName || ''}`.trim() || contact.accountManager.email || 'Unknown'
                : 'Unknown';

              return (
                <Table.Row
                  key={contact.id}
                  className="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                >
                  {/* Contact Name with Avatar */}
                  <Table.Cell className="px-4 py-3 whitespace-nowrap">
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm">
                        {initials}
                      </div>
                      <div>
                        <div className="font-medium text-sm text-gray-900 dark:text-white">
                          {fullName}
                        </div>
                        <div className="text-xs text-gray-500 dark:text-gray-400">
                          {contact.pronoun}
                        </div>
                      </div>
                    </div>
                  </Table.Cell>

                  {/* Company */}
                  <Table.Cell className="px-4 py-3 whitespace-nowrap">
                    <span className="text-sm text-gray-900 dark:text-white">{company}</span>
                  </Table.Cell>

                  {/* Email */}
                  <Table.Cell className="px-4 py-3 whitespace-nowrap">
                    {email ? (
                      <a
                        href={`mailto:${email}`}
                        className="text-sm text-blue-600 dark:text-blue-400 hover:underline"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {email}
                      </a>
                    ) : (
                      <span className="text-sm text-gray-400">-</span>
                    )}
                  </Table.Cell>

                  {/* Phone */}
                  <Table.Cell className="px-4 py-3">
                    {phoneNumbers.length > 0 ? (
                      <div className="flex flex-col gap-1">
                        {phoneNumbers.map((phone: any, i: number) => (
                          <a
                            key={i}
                            href={`tel:${phone.number}`}
                            className="text-sm text-blue-600 dark:text-blue-400 hover:underline block"
                            onClick={(e) => e.stopPropagation()}
                          >
                            {phone.number} ({phone.type})
                          </a>
                        ))}
                      </div>
                    ) : (
                      <span className="text-sm text-gray-400">-</span>
                    )}
                  </Table.Cell>

                  {/* Title */}
                  <Table.Cell className="px-4 py-3 whitespace-nowrap">
                    <span className="text-sm text-gray-900 dark:text-white">{title}</span>
                  </Table.Cell>

                  {/* Status */}
                  <Table.Cell className="px-4 py-3 whitespace-nowrap">
                    <InlineStatusEditor status={status} contactId={contact.id} onUpdate={onUpdate} />
                  </Table.Cell>

                  {/* Account Manager */}
                  <Table.Cell className="px-4 py-3 whitespace-nowrap">
                    <span className="text-sm text-gray-900 dark:text-white">{accountManager}</span>
                  </Table.Cell>

                  {/* Actions */}
                  <Table.Cell className="px-4 py-3 whitespace-nowrap text-center">
                    <div className="flex items-center justify-center gap-2">
                      <EditContactModal contact={contact} onUpdate={onUpdate} />
                      <DeleteContactModal contact={contact} onUpdate={onUpdate} />
                    </div>
                  </Table.Cell>
                </Table.Row>
              );
            })
          )}
        </Table.Body>
      </Table>
    </div>
  );
};

export const EditContactModal: FC<{ contact: any, onUpdate: any }> = ({ contact, onUpdate }) => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(contact);
  const [companies, setCompanies] = useState<any[]>([]);

  const EXCLUDED_FIELDS = ["id", "accountManager", "accountManagerId", "companyId", "createdAt", "updatedAt"];
  
  // Status options
  const STATUS_OPTIONS = [
    { value: "NEW", label: "New" },
    { value: "CONTACTED", label: "Contacted" },
    { value: "INVALID", label: "Invalid" },
    { value: "FOLLOW_UP", label: "Follow Up" },
  ];

  useEffect(() => {
    // Initialize formData with proper company handling
    const initialData = {
      ...contact,
      // Ensure company is properly set - use companyId if company object is not available
      company: contact.company || (contact.companyId ? { id: contact.companyId } : null),
    };
    setFormData(initialData);
    
    // Load companies for dropdown
    const fetchCompanies = async () => {
      try {
        const res = await companyService.listCompanies();
        setCompanies(res.data.companies || []);
      } catch (err) {
        console.error("Failed to load companies", err);
      }
    };
    fetchCompanies();
  }, [contact]);

  const handleChange = (key: string, value: any) => {
    setFormData((prev: any) => ({ ...prev, [key]: value }));
  };

  const handlePhoneChange = (index: number, field: string, value: string) => {
    const updatedPhones = [...formData.phoneNumbers];
    updatedPhones[index] = { ...updatedPhones[index], [field]: value };
    handleChange("phoneNumbers", updatedPhones);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      // Prepare update payload - use companyId from company object or direct companyId
      const companyId = formData.company?.id || formData.companyId || null;
      const updatePayload = {
        ...formData,
        companyId: companyId,
      };
      // Remove the company object from payload as API expects companyId
      delete updatePayload.company;
      await contactService.updateContact(contact.id, updatePayload);
      setOpen(false);
      onUpdate();
    } catch (error) {
      console.error("Failed to update contact", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={(e: any) => { 
          e.stopPropagation(); 
          setOpen(true); 
        }}
        className="p-2.5 text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-lg transition-all duration-200 hover:scale-110 shadow-sm hover:shadow-md"
        title="Edit contact"
      >
        <HiOutlinePencilAlt className="w-5 h-5" />
      </button>

      <Modal size="xl" onClick={(e) => e.stopPropagation()} onClose={() => setOpen(false)} show={isOpen}>
        <Modal.Header className="border-b border-gray-200 !p-4 dark:border-gray-700">
          <strong>Edit Contact</strong>
        </Modal.Header>
        <Modal.Body className="max-h-[70vh] overflow-y-auto">
          <div className="space-y-4">
            {/* Basic Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Basic Information</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {/* Pronoun Dropdown */}
                <div className="flex flex-col">
                  <Label htmlFor="pronoun" className="mb-2">
                    Pronoun <span className="text-red-500">*</span>
                  </Label>
                  <select
                    id="pronoun"
                    name="pronoun"
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    value={formData.pronoun || ""}
                    onChange={(e) => handleChange("pronoun", e.target.value)}
                    required
                  >
                    <option value="">Select Pronoun</option>
                    {PRONOUN_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* First Name */}
                <div className="flex flex-col">
                  <Label htmlFor="firstName" className="mb-2">
                    First Name <span className="text-red-500">*</span>
                  </Label>
                  <TextInput
                    id="firstName"
                    name="firstName"
                    value={formData.firstName || ""}
                    onChange={(e) => handleChange("firstName", e.target.value)}
                    required
                  />
                </div>

                {/* Last Name */}
                <div className="flex flex-col">
                  <Label htmlFor="lastName" className="mb-2">
                    Last Name <span className="text-red-500">*</span>
                  </Label>
                  <TextInput
                    id="lastName"
                    name="lastName"
                    value={formData.lastName || ""}
                    onChange={(e) => handleChange("lastName", e.target.value)}
                    required
                  />
                </div>

                {/* Title Dropdown */}
                <div className="flex flex-col">
                  <Label htmlFor="title" className="mb-2">Job Title</Label>
                  <select
                    id="title"
                    name="title"
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    value={formData.title || ""}
                    onChange={(e) => handleChange("title", e.target.value)}
                  >
                    <option value="">Select Title</option>
                    {TITLE_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Company Dropdown */}
                <div className="flex flex-col">
                  <Label htmlFor="company" className="mb-2">Company</Label>
                  <select
                    id="company"
                    value={formData.company?.id || formData.companyId || ""}
                    onChange={(e) => {
                      const selectedCompanyId = e.target.value ? Number(e.target.value) : null;
                      const selectedCompany = selectedCompanyId 
                        ? companies.find(c => c.id === selectedCompanyId) 
                        : null;
                      handleChange("company", selectedCompany);
                      handleChange("companyId", selectedCompanyId);
                    }}
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  >
                    <option value="">-- Select Company --</option>
                    {companies.map((company) => (
                      <option key={company.id} value={company.id}>
                        {company.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Status Dropdown */}
                <div className="flex flex-col">
                  <Label htmlFor="status" className="mb-2">Status</Label>
                  <select
                    id="status"
                    name="status"
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    value={formData.status || "NEW"}
                    onChange={(e) => handleChange("status", e.target.value)}
                  >
                    {STATUS_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Contact Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Contact Information</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {/* Email */}
                <div className="flex flex-col">
                  <Label htmlFor="email" className="mb-2">Email</Label>
                  <TextInput
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email || ""}
                    onChange={(e) => handleChange("email", e.target.value)}
                  />
                </div>

                {/* LinkedIn URL */}
                <div className="flex flex-col">
                  <Label htmlFor="linkedinUrl" className="mb-2">LinkedIn URL</Label>
                  <TextInput
                    id="linkedinUrl"
                    name="linkedinUrl"
                    type="url"
                    value={formData.linkedinUrl || ""}
                    onChange={(e) => handleChange("linkedinUrl", e.target.value)}
                  />
                </div>
              </div>

              {/* Phone Numbers */}
              <div className="mt-4">
                <Label className="mb-2 block">Phone Numbers</Label>
                {formData.phoneNumbers && Array.isArray(formData.phoneNumbers) && formData.phoneNumbers.map((phone: any, index: number) => (
                  <div key={index} className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-2">
                    <div className="sm:col-span-2">
                      <TextInput
                        placeholder="Phone number (e.g., +1 234 567 8900)"
                        value={phone.number || ""}
                        onChange={(e) => handlePhoneChange(index, "number", e.target.value)}
                      />
                    </div>
                    <div>
                      <select
                        className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white w-full"
                        value={phone.type || "Work"}
                        onChange={(e) => handlePhoneChange(index, "type", e.target.value)}
                      >
                        {PHONE_TYPE_OPTIONS.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Additional Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Additional Information</h3>
              <div className="grid grid-cols-1 gap-4">
                {/* Background Info */}
                <div className="flex flex-col">
                  <Label htmlFor="backgroundInfo" className="mb-2">Background Information</Label>
                  <textarea
                    id="backgroundInfo"
                    name="backgroundInfo"
                    rows={4}
                    className="block w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                    value={formData.backgroundInfo || ""}
                    onChange={(e) => handleChange("backgroundInfo", e.target.value)}
                  />
                </div>

                {/* Newsletter Subscription */}
                <div className="flex items-center">
                  <Checkbox
                    id="hasNewsletter"
                    checked={formData.hasNewsletter || false}
                    onChange={(e) => handleChange("hasNewsletter", e.target.checked)}
                  />
                  <Label htmlFor="hasNewsletter" className="ml-2">
                    Subscribe to Newsletter
                  </Label>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-t border-gray-200 dark:border-gray-700 !p-4">
          <div className="flex justify-end gap-2 w-full">
            <Button color="gray" onClick={() => setOpen(false)} disabled={loading}>
              Cancel
            </Button>
            <Button color="primary" onClick={handleSave} disabled={loading}>
              {loading ? "Saving..." : "Save Changes"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const EditActiveStateModal: FC<{ user: any }> = ({ user }) => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  // const { dummy, setDummy } = useAppContext();

  // Initial empty form data
  const [formData, setFormData] = useState({
    startDate: "",
    plan: "",
    isPaid: "",
    paidMonths: "",
  });
  const [plans, setPlans] = useState<{ _id: string; name: string }[]>([]);
  const owner = sessionStorage.getItem("user");
  if (!owner) {
    toast.error("Owner not found in session storage.");
    return;
  }

  const parsedUser = JSON.parse(owner);
  const ownerId = parsedUser._id;
  // useEffect(() => {
  //   const fetchPlans = async () => {
  //     try {
  //       const response = await planService.getPlanOByOwnerId(ownerId);
  //       setPlans(response.data.data);
  //     } catch (error) {
  //       toast.error("Failed to load plans.");
  //     }
  //   };

  //   fetchPlans();
  // }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox" ? (e.target as HTMLInputElement).checked : value,
    }));
  };
  // const handleToggleActiveState = async (
  //   event: React.MouseEvent,
  //   member: any
  // ) => {
  //   event.stopPropagation();
  //   try {
  //     const updatedStatus = !member.active; // Toggle the current active state
  //     const data = { active: updatedStatus };

  //     // Call the update API
  //     await memberService.updateMember(member._id, data);
  //     setDummy(!dummy)
  //     toast.success("Active status updated successfully");
  //   } catch (error: any) {
  //     toast.error(
  //       error?.response?.data?.message || "Failed to update active status."
  //     );
  //   }
  // };
  // const openModal = (e: any, member: any) => {
  //   if (!member.active) {
  //     // setFormData({
  //     //   startDate: user.startDate
  //     //     ? format(new Date(user.startDate), "yyyy-MM-dd")
  //     //     : "",
  //     //   plan: user.plan?._id || "",
  //     //   isPaid: user.isPaid || "",
  //     //   paidMonths: user.paidMonths || "",
  //     // });
  //     setOpen(true);
  //   } else {
  //     handleToggleActiveState(e, member);
  //   }
  // };
  const handleDateChange = (date: Date | null, field: string) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: date ? format(date, "dd/MM/yyyy") : "",
    }));
  };
  // const handleSaveChanges = async () => {
  //   try {
  //     const formattedData = {
  //       ...formData,
  //       startDate: formData.startDate
  //         ? format(parse(formData.startDate, "dd/MM/yyyy", new Date()), "yyyy-MM-dd")
  //         : null,
  //       active: true,
  //       paidMonths: Number(formData.paidMonths) + 1
  //     };
  //     setLoading(true);

  //     // Call the update API
  //     await memberService.updateMember(user._id, formattedData);

  //     setDummy(!dummy);
  //     setOpen(false);
  //     toast.success("Active status updated successfully");
  //   } catch (error: any) {
  //     console.error("Error while updating active status", error);
  //     toast.error(
  //       error?.response?.data?.message || "Failed to update active status."
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <>
      <Button
        color={user.active ? "success" : "failure"}
        onClick={(e: any) => { e.stopPropagation() }}
      >
        <div className="flex items-center gap-x-2">
          {user.active ? (
            <HiCheckCircle className="text-lg " />
          ) : (
            <HiXCircle className="text-lg" />
          )}
          {user.active ? "Deactivate" : "Activate"}
        </div>
      </Button>
      <Modal
        size={"2xl"}
        onClick={(e: any) => {
          e.stopPropagation();
        }}
        onClose={() => setOpen(false)}
        show={isOpen}
      >
        <Modal.Header className="border-b border-gray-200 !p-6 dark:border-gray-700">
          <strong>Change Status</strong>
        </Modal.Header>
        <Modal.Body>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">

            {/* Date Fields with DatePicker */}
            <div className="w-full">
              <label htmlFor="startDate">
                Start Date <span className="text-red-500">*</span>
              </label>
              <div className="mt-1 w-full">
                <DatePicker
                  id="startDate"
                  selected={
                    formData.startDate
                      ? new Date(
                        formData.startDate.split("/").reverse().join("-")
                      )
                      : null
                  }
                  className="mt-1 p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm w-full"
                  onChange={(date) => handleDateChange(date, "startDate")}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Select Start Date"
                />
              </div>
            </div>


            <div>
              <Label htmlFor="plan">Plan</Label>
              <select
                id="plan"
                name="plan"
                value={formData.plan}
                onChange={handleChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              >
                <option value="">Select Plan</option>
                {plans.map((plan: any) => (
                  <option key={plan._id} value={plan._id}>
                    {plan.planName}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <Label htmlFor="isPaid">Paid Status</Label>
              <select
                id="isPaid"
                name="isPaid"
                value={formData.isPaid}
                onChange={handleChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              >
                <option value="">Select</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div>
              <Label htmlFor="paidMonths">Number of Paid Months</Label>
              <TextInput
                id="paidMonths"
                placeholder="eg. 2"
                name="paidMonths"
                type={formData.isPaid === "true" ? "number" : "text"}
                value={formData.paidMonths}
                onChange={handleChange}
                disabled={formData.isPaid !== "true"}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            color="primary"
            className="flex justify-center items-center"
            onClick={() => { }}
            disabled={loading}
          >
            <HiSave className="text-xl mr-2" />
            {loading ? "Saving..." : "Save Changes"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const ImportContactsModal: FC<{ contact: any; onUpdate: () => void }> = ({ contact, onUpdate }) => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null) as any;
  const [uploadErrors, setUploadErrors] = useState<string[]>([]);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.files?.[0];
    if (selected) setFile(selected);
  };

  const handleUpload = async () => {
    if (!file) return;

    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("accountManagerId", user.id);
    
    try {
      const response = await contactService.bulkUploadContacts(formData);
      toast.success(`Successfully uploaded ${response.data?.created || 0} contacts!`);
      onUpdate();
      setOpen(false);
      setFile(null);
    } catch (error: any) {
      console.error("Upload error:", error);
      
      // Extract error message
      let errorMessage = "Upload failed";
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      // Parse error message to extract row errors
      const errorLines = errorMessage.split("\n").filter((line: string) => line.trim());
      const hasRowErrors = errorLines.some((line: string) => line.includes("Row "));
      
      if (hasRowErrors) {
        // Set errors and show modal
        setUploadErrors(errorLines);
        setShowErrorModal(true);
        toast.error("Upload failed - check error details", { duration: 5000 });
      } else {
        toast.error(errorMessage, { duration: 5000 });
      }
    } finally {
      setLoading(false);
    }
  };
  function downloadContactTemplateHeadersOnly() {
    const headers = [
      "pronoun",
      "firstName",
      "lastName",
      "title",
      "companyName",
      "email",
      "linkedinUrl",
      "backgroundInfo",
      "hasNewsletter",
      "phoneNumbers",
      "status"
    ];

    // Create worksheet with one empty row, using headers
    const worksheet = XLSX.utils.json_to_sheet([{}], { header: headers });

    // Ensure headers appear in the desired order
    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Template");

    XLSX.writeFile(workbook, "contact_template.xlsx");
  }


  return (
    <>
      <Button color="gray" onClick={(e: any) => {
        e.stopPropagation();
        setOpen(true);
      }}>
        <div className="flex items-center gap-x-2">
          <HiUpload className="text-lg" />
          Import
        </div>
      </Button>

      {/* Error Details Modal */}
      <Modal onClose={() => setShowErrorModal(false)} show={showErrorModal} size="xl">
        <Modal.Header className="px-6 pb-0 pt-6 border-b border-red-200 dark:border-red-800">
          <div className="flex items-center gap-2">
            <HiExclamationCircle className="text-red-600 dark:text-red-400 text-2xl" />
            <span className="text-xl font-semibold text-red-600 dark:text-red-400">Upload Errors</span>
          </div>
        </Modal.Header>
        <Modal.Body className="px-6 pb-6 pt-4">
          <div className="mb-4">
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
              Please fix the following errors in your Excel file and try again:
            </p>
            <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 max-h-96 overflow-y-auto">
              <div className="space-y-2">
                {uploadErrors.map((error, idx) => {
                  const isRowError = error.includes("Row ");
                  return (
                    <div
                      key={idx}
                      className={`text-sm ${
                        isRowError
                          ? "text-red-700 dark:text-red-300 font-medium"
                          : "text-red-600 dark:text-red-400"
                      }`}
                    >
                      {isRowError ? (
                        <div className="flex items-start gap-2">
                          <span className="font-bold">•</span>
                          <span>{error}</span>
                        </div>
                      ) : (
                        <div className="font-semibold mb-1">{error}</div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
            <p className="text-sm text-blue-800 dark:text-blue-300">
              <strong>Tip:</strong> Valid status values are: <code className="bg-blue-100 dark:bg-blue-900 px-1 rounded">NEW</code>, <code className="bg-blue-100 dark:bg-blue-900 px-1 rounded">CONTACTED</code>, <code className="bg-blue-100 dark:bg-blue-900 px-1 rounded">INVALID</code>, <code className="bg-blue-100 dark:bg-blue-900 px-1 rounded">FOLLOW_UP</code>
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button color="gray" onClick={() => setShowErrorModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal onClose={() => { setOpen(false); setFile(null); setUploadErrors([]); }} show={isOpen} size="md">
        <Modal.Header className="px-6 pb-0 pt-6">
          <span className="sr-only">Import Contact</span>
        </Modal.Header>
        <Modal.Body className="px-6 pb-6 pt-0">
          <div className="flex justify-between items-center my-4">
            <p className="text-xl text-gray-500 flex justify-center ">
              Download Template
            </p>
            <Button color="primary" onClick={downloadContactTemplateHeadersOnly} isProcessing={loading}>
              Download
            </Button>
          </div>
          <hr className="my-4" />
          <div className="mb-4">
            <div className="flex items-center justify-center w-full">
              <label htmlFor="dropzone-file" className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400"><span className="font-semibold">Click to upload</span> or drag and drop</p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">XLSX, XLS (Max upload size - 10mb)</p>
                  <span className="font-semibold text-xs text-gray-500 dark:text-gray-400">{file?.name}</span>
                </div>
                <input type="file"
                  accept=".xlsx, .xls"
                  onChange={handleFileChange} id="dropzone-file" className="hidden" />
              </label>
            </div>

          </div>
          <div className="flex gap-3">
            <Button color="primary" onClick={handleUpload} isProcessing={loading} disabled={!file}>
              Upload
            </Button>
            <Button color="gray" onClick={() => { setOpen(false); setFile(null) }} disabled={loading}>
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
const DeleteContactModal: FC<{ contact: any; onUpdate: () => void }> = ({ contact, onUpdate }) => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = async (e: any) => {
    e.stopPropagation();
    setLoading(true);
    try {
      await contactService.deleteContact(contact.id);
      setOpen(false);
      onUpdate(); // refresh list
    } catch (error) {
      console.error("Delete failed", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={(e: any) => {
          e.stopPropagation();
          setOpen(true);
        }}
        className="p-2.5 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-all duration-200 hover:scale-110 shadow-sm hover:shadow-md"
        title="Delete contact"
      >
        <HiTrash className="w-5 h-5" />
      </button>

      <Modal onClose={() => setOpen(false)} show={isOpen} size="md">
        <Modal.Header className="px-6 pb-0 pt-6">
          <span className="sr-only">Delete contact</span>
        </Modal.Header>
        <Modal.Body className="px-6 pb-6 pt-0">
          <div className="flex flex-col items-center gap-y-6 text-center">
            <HiOutlineExclamationCircle className="text-7xl text-red-500" />
            <p className="text-xl text-gray-500">
              Are you sure you want to delete this contact?
            </p>
            <div className="flex items-center gap-x-3">
              <Button color="failure" onClick={handleDelete} isProcessing={loading}>
                Yes, I'm sure
              </Button>
              <Button color="gray" onClick={(e: any) => { e.stopPropagation(); setOpen(false) }} disabled={loading}>
                No, cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  setCurrentPage: (page: number) => void;
}
export const Pagination: FC<PaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  setCurrentPage,
}) => {
  // Show max 5 page numbers at a time
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      }
    }
    
    return pages;
  };

  return (
    <div className="flex items-center justify-between px-4 py-4 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 mt-4 rounded-b-lg">
      <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
        <span>
          Showing <span className="font-semibold text-gray-900 dark:text-white">{(currentPage - 1) * itemsPerPage + 1}</span> to{" "}
          <span className="font-semibold text-gray-900 dark:text-white">{Math.min(currentPage * itemsPerPage, totalItems)}</span> of{" "}
          <span className="font-semibold text-gray-900 dark:text-white">{totalItems}</span> contacts
        </span>
      </div>

      <div className="flex items-center gap-2">
        <Button
          size="sm"
          color="gray"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))}
          className="disabled:opacity-50"
        >
          <HiChevronLeft className="h-4 w-4" />
        </Button>

        {getPageNumbers().map((page, index) => (
          page === '...' ? (
            <span key={`ellipsis-${index}`} className="px-2 text-gray-500">...</span>
          ) : (
            <Button
              key={page}
              size="sm"
              color={currentPage === page ? "primary" : "gray"}
              onClick={() => setCurrentPage(page as number)}
              className="min-w-[36px]"
            >
              {page}
            </Button>
          )
        ))}

        <Button
          size="sm"
          color="gray"
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(Math.min(currentPage + 1, totalPages))}
          className="disabled:opacity-50"
        >
          <HiChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default UserListPage;
